import script from "./App.vue?vue&type=script&setup=true&lang=js"
export * from "./App.vue?vue&type=script&setup=true&lang=js"

import "./App.vue?vue&type=style&index=0&id=0aa916d8&lang=scss&scoped=true"
import "./App.vue?vue&type=style&index=1&id=0aa916d8&lang=scss"

import exportComponent from "../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0aa916d8"]])

export default __exports__